<template>
<div>
      <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                        :value="myValue"
                        :options="options"
                        @change="updateValue"
                        @input="inputValue"
                        text-field="name"
                        :disabled="disabled"
                        >
                        <option slot="first" :value="null">Escolha...</option>
        </b-form-select>
</div>
</template>

<script>
var _ = require('lodash');
export default {
   data(){
        return {myValue:null }
    },
    props:{
        options:{},
        value:{},
        disabled:{
            type:Boolean,
            default:false
        }

    },
    created:function(){
        this.myValue = this.value
    },
    
    watch:{
        value:function(val){
            this.myValue = val
        }
    },
    
    computed:{
        myoptions:function(){
            var options = [...this.options];
            var myoptions = [];
            _.each(options, o=>{
                o.name = o.name + "(+"+o.price+")";
                myoptions.push({...o})
            })
            return myoptions;
        },
    },
    
    methods:{
         updateValue:function(val){
            this.myValue = val
            this.$emit('change',val)
            this.$emit('input',val)
        },
         inputValue:function(val){
            this.myValue = val
            this.$emit('input',val)
        },

    }
}
</script>

<style>

</style>
